import React from 'react'
import { NavLink, Outlet, useParams } from 'react-router-dom'


const Branches = () => {

    const { organization } = useParams()
    return (
        <div className=''>
            <div className="branches-menu">
                <div className='branches-menu-item'>
                    <NavLink to={`/${organization}/admin/branches`}>Branches</NavLink>
                </div>
                  <div className='branches-menu-item'>
                    <NavLink to={`/${organization}/admin/branches/parent`}>Parent</NavLink>
                </div>
                <div className='branches-menu-item'>
                    <NavLink to={`/${organization}/admin/branches/requested`}>Sent Requests</NavLink>
                </div>
                <div className='branches-menu-item'>
                    <NavLink to={`/${organization}/admin/branches/requesting`}>Received Requests</NavLink>
                </div>
                <div className='branches-menu-item'>
                    <NavLink to={`/${organization}/admin/branches/suggested`}>Suggested Parents</NavLink>
                </div>
            </div>
            <div className="org-content">
                <Outlet />
            </div>
        </div>
    )
}

export default Branches